const FormError = {
    baseStyle: {
        text: {
            flexDir: "row-reverse",
            my: 1
        }
    }
}

export default FormError;